import script from "./FaceMergeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaceMergeModal.vue?vue&type=script&setup=true&lang=ts"

import "./FaceMergeModal.vue?vue&type=style&index=0&id=89b58668&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b58668"]])

export default __exports__